import $ from 'jquery';
import { getState } from '~src/state';
import { withCanvasPreparedForExport } from '~core/exportIMG';
import { getCurrentPage } from './currentPageImage';

// Le miniature della sidebar sono alte al massimo 150 px di CSS: 300 px
// bastano anche sugli schermi 2x.
export const PAGE_THUMBNAIL_SIZE = 300;
const THUMBNAIL_DELAY_MS = 1000;

let thumbnailTimeout = null;

export const updateSidebarPageThumbnail = (pageIndex, src) => {
  $(
    `#editor-sidebar-pages [data-page-index="${pageIndex}"] .editor-sidebar-page-preview img`
  ).attr('src', src);
};

// toCanvasElement(1) riusa le cache degli oggetti come un render a schermo.
// Un moltiplicatore piccolo le farebbe ridisegnare tutte due volte: in
// piccolo per la miniatura e di nuovo in grande al render successivo.
const renderThumbnail = (canvas) => {
  const scene = withCanvasPreparedForExport(canvas, () =>
    canvas.toCanvasElement(1)
  );

  try {
    if (!scene.width || !scene.height) {
      throw new Error(
        `Canvas rendered an empty ${scene.width}x${scene.height} image`
      );
    }

    const scale = Math.min(
      1,
      PAGE_THUMBNAIL_SIZE / Math.max(scene.width, scene.height)
    );
    const thumbnail = document.createElement('canvas');
    thumbnail.width = Math.max(1, Math.round(scene.width * scale));
    thumbnail.height = Math.max(1, Math.round(scene.height * scale));

    const context = thumbnail.getContext('2d');
    context.imageSmoothingQuality = 'high';
    context.drawImage(scene, 0, 0, thumbnail.width, thumbnail.height);

    const dataUrl = thumbnail.toDataURL('image/jpeg', 0.8);
    if (!dataUrl || dataUrl === 'data:,') {
      throw new Error(
        `Thumbnail returned an empty data URL for ${thumbnail.width}x${thumbnail.height}`
      );
    }

    return dataUrl;
  } finally {
    // Libera subito la memoria del canvas a piena risoluzione.
    scene.width = 0;
    scene.height = 0;
  }
};

export const generateCurrentPageThumbnail = () => {
  if (getState('isErasing', false)) {
    return;
  }
  if (getState('isExporting', false)) {
    return;
  }
  // Durante il cambio pagina il canvas non mostra ancora la pagina corrente.
  if (getState('isChangingPage', false)) {
    return;
  }
  const canvas = window.canvas;
  if (
    !canvas ||
    typeof canvas.getZoom !== 'function' ||
    typeof canvas.toCanvasElement !== 'function'
  ) {
    console.warn(
      'Cannot generate current page thumbnail',
      new Error('Canvas is not ready')
    );
    return;
  }

  const isZoomed = canvas.getZoom();
  if (isZoomed !== 1) {
    return;
  }

  const page = getCurrentPage();
  if (!page) {
    return;
  }

  // toCanvasElement annulla il render già richiesto con requestRenderAll: va
  // richiesto di nuovo, o lo schermo resta indietro e il dispatcher di
  // after:render non segna la pagina come modificata.
  const hadPendingRender = Boolean(canvas.isRendering);

  try {
    page.thumbnail = renderThumbnail(canvas);
  } catch (error) {
    console.warn('Cannot generate current page thumbnail', error);
    return;
  } finally {
    if (hadPendingRender) {
      canvas.requestRenderAll();
    }
  }

  clearTimeout(thumbnailTimeout);
  thumbnailTimeout = null;
  updateSidebarPageThumbnail(getState('currentPageIndex') || 0, page.thumbnail);
};

export const scheduleCurrentPageThumbnail = () => {
  clearTimeout(thumbnailTimeout);
  thumbnailTimeout = setTimeout(() => {
    thumbnailTimeout = null;
    generateCurrentPageThumbnail();
  }, THUMBNAIL_DELAY_MS);
};

// Chi lascia la pagina non può aspettare il debounce: dopo il cambio il canvas
// mostra un'altra pagina.
export const flushCurrentPageThumbnail = () => {
  if (!thumbnailTimeout) {
    return;
  }

  clearTimeout(thumbnailTimeout);
  thumbnailTimeout = null;
  generateCurrentPageThumbnail();
};
